export class TemperatureInspectionVM{
    public InspectionDate:Date;
    public EquipmentId:number;
    public SMU:number;
    public PinTemperatureL: TemperatureForPinsVM[];
    public PinTemperatureR: TemperatureForPinsVM[];
    public ChainL:number;
    public ChainR:number;
    public AmbientTem:number;
}

export class TemperatureForPinsVM{
    public PinNo:number;
    public temperature:number;
}

export class TemperatureInspectionListVM{
    public  InspectionSummary:TemperatureInspectionSummaryVM;
    public LeftInspectionDetails:TemperatureInspectionDetailVM[];
    public RightInspectionDetails:TemperatureInspectionDetailVM[];
}

export class TemperatureInspectionSummaryVM{
    public InspectionID:number
    public InspectionDate:Date;
    public EquipmentId:number;
    public SMU:number;
    public ChainL:number;
    public ChainR:number;
    public AmbientTem:number;
    public WarningL:string;
    public WarningR:string;
    public Inspector:string;
    public Eval:boolean;
    public Note:string;
    public IsChainLReplace:boolean;
    public IsChainRReplace:boolean;
    public InspectionImage :string;

}

export class TemperatureInspectionDetailVM{
    public InspectionId:number;
    public InspectionDetailId:number;
    public PinNo:number;
    public temperature:number;
    public Outlier:boolean;
    public Side:number;
    public Comment:string;
    public Image:string;
}

export class UpdateTemperatureDateAmbient{
    public InspectionDate:Date;
    public Ambientempearture :number;
    public InspectionId:number;
}

export class LoadInspectionListVM{
    public InspectionId:number;
    public EquipmentId:number;
    public LoadRecent:boolean;
    public LoadPrevious:boolean;
}

export class editEquipment{
    public editableSerialNo:boolean;
    public editUnitNo:boolean;
    public editAdditionalUnitNo:boolean;

  

}




